import { DisplayClassAndEditionWriteMode } from '@/components/templates/bibliography-collection-bulk-edit/BibliographyCollectionBulkEditChangeInformation.vue'

export interface BulkUpdateCollectionsRequest {
  ids: number[]
  holdingBranchCode: string
  shelfType: string
  shelfTypeErase: boolean
  collectionType: string
  handlingType: string
  handlingTypeErase: boolean
  appendixCode: string
  appendixCodeErase: boolean
  storeType: string
  storeTypeErase: boolean
  processedDate: string
  processedBranchCode: string
  processedPlaceCode: string
  specialShelfLimitDate: string
  borrowingDate: string
  borrowingDueDate: string
  mark: string
  markErase: boolean
  ndc: string
  ndcErase: boolean
  book: string
  bookErase: boolean
  sub: string
  subErase: boolean
  status: string
  forwardingBranchCode: string
  removeReason: string
  removeDate: string
  removeExpectedDate: string
  removePrevent: boolean
  materialFormat: string
  displayClass: string
  displayClassAndEditionWriteMode: DisplayClassAndEditionWriteMode
  edition: string
  editionErase: boolean
  publishDate: string
  workMemo: string
  workMemoErase: boolean
  displayMemo: string
  displayMemoErase: boolean
  localMemo: string
  localMemoErase: boolean
  _isUpdateChildCollection: boolean
}

export function BulkUpdateCollectionsRequestToJSON(
  value: BulkUpdateCollectionsRequest
): any {
  return {
    ids: value.ids.length !== 0 ? value.ids : undefined,
    holding_branch_code:
      value.holdingBranchCode !== '' ? value.holdingBranchCode : undefined,
    shelf_type: value.shelfType !== '' ? value.shelfType : undefined,
    shelf_type_erase: value.shelfTypeErase ? value.shelfTypeErase : undefined,
    collection_type:
      value.collectionType !== '' ? value.collectionType : undefined,
    handling_type: value.handlingType !== '' ? value.handlingType : undefined,
    handling_type_erase: value.handlingTypeErase
      ? value.handlingTypeErase
      : undefined,
    appendix_code: value.appendixCode !== '' ? value.appendixCode : undefined,
    appendix_code_erase: value.appendixCodeErase
      ? value.appendixCodeErase
      : undefined,
    store_type: value.storeType !== '' ? value.storeType : undefined,
    store_type_erase: value.storeTypeErase ? value.storeTypeErase : undefined,
    processed_date:
      value.processedDate !== '' ? value.processedDate : undefined,
    processed_branch_code:
      value.processedBranchCode !== '' ? value.processedBranchCode : undefined,
    processed_place_code:
      value.processedPlaceCode !== '' ? value.processedPlaceCode : undefined,
    special_shelf_limit_date:
      value.specialShelfLimitDate !== ''
        ? value.specialShelfLimitDate
        : undefined,
    borrowing_date:
      value.borrowingDate !== '' ? value.borrowingDate : undefined,
    borrowing_due_date:
      value.borrowingDueDate !== '' ? value.borrowingDueDate : undefined,
    mark: value.mark !== '' ? value.mark : undefined,
    mark_erase: value.markErase ? value.markErase : undefined,
    ndc: value.ndc !== '' ? value.ndc : undefined,
    ndc_erase: value.ndcErase ? value.ndcErase : undefined,
    book: value.book !== '' ? value.book : undefined,
    book_erase: value.bookErase ? value.bookErase : undefined,
    sub: value.sub !== '' ? value.sub : undefined,
    sub_erase: value.subErase ? value.subErase : undefined,
    status: value.status !== '' ? value.status : undefined,
    forwarding_branch_code:
      value.forwardingBranchCode !== ''
        ? value.forwardingBranchCode
        : undefined,
    remove_reason: value.removeReason !== '' ? value.removeReason : undefined,
    remove_date: value.removeDate !== '' ? value.removeDate : undefined,
    remove_expected_date:
      value.removeExpectedDate !== '' ? value.removeExpectedDate : undefined,
    remove_prevent: value.removePrevent ? value.removePrevent : undefined,
    material_format:
      value.materialFormat !== '' ? value.materialFormat : undefined,
    display_class: value.displayClass !== '' ? value.displayClass : undefined,
    display_class_and_edition_write_mode:
      value.displayClassAndEditionWriteMode ?? undefined,
    edition: value.edition !== '' ? value.edition : undefined,
    edition_erase: value.editionErase ? value.editionErase : undefined,
    publish_date: value.publishDate ? value.publishDate : undefined,
    work_memo: value.workMemo !== '' ? value.workMemo : undefined,
    work_memo_erase: value.workMemoErase ? value.workMemoErase : undefined,
    display_memo: value.displayMemo !== '' ? value.displayMemo : undefined,
    display_memo_erase: value.displayMemoErase
      ? value.displayMemoErase
      : undefined,
    local_memo: value.localMemo !== '' ? value.localMemo : undefined,
    local_memo_erase: value.localMemoErase ? value.localMemoErase : undefined,
    _is_update_child_collection: value._isUpdateChildCollection ?? undefined
  }
}
